import React from 'react';
import PropTypes from 'prop-types';
import {Field, reduxForm} from 'redux-form';
import i18n from "i18next";
import Checkbox from 'material-ui/Checkbox';
import RaisedButton from 'material-ui/RaisedButton';
import Avatar from "material-ui/Avatar";
import styles from '../../styles/styles'
import withTranslation from "../../hoc/withTranslation";
import {
    renderFavoriteCheckbox,
    renderSuperSelectField,
    renderTextField,
    renderVisibleCheckBox,
} from '../../services/form';
import '../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import ControlledEditor from "../form/ControlledEditor/ControlledEditor";
import ModuleService from "../../services/module";
import { RICHTEXT } from '../../constants/customfiled';

const validate = values => {
    const errors = {};
    const requiredFields = [
        'title',
        'excerpt',
        'content'
    ];
    requiredFields.forEach(field => {
        if (!values[field]) {
            errors[field] = i18n.t('generic.required');
        }
    });
    if (values['tag'] !== undefined && values['tag'] !== null && values['tag'] !== '' && values['tag'].length > 100) {
        errors['tag'] = i18n.t('generic.tag_length_gt_100');
    }
    return errors;
};


const renderCheckbox = ({input, label}) => (
    <Checkbox
        label={label}
        onCheck={input.onChange}
    />
);

export class NewsForm extends React.Component {

    static propTypes = {
        app: PropTypes.object,
        types: PropTypes.arrayOf(PropTypes.object),
        news: PropTypes.object,
        onFormReset: PropTypes.func,
        customFields: PropTypes.arrayOf(PropTypes.object)
    };

    // Handlers

    onResetForm = () => {
        this.props.reset();

        if (this.props.onFormReset) {
            this.props.onFormReset();
        }
    };

    // Render

    render() {
        const {handleSubmit, pristine, submitting} = this.props;
        return (
            <form onSubmit={handleSubmit}>
                <div>
                    <Field
                        id="is_favorite"
                        name="is_favorite"
                        component={renderFavoriteCheckbox}
                        label="Favorite"
                    />
                    <Field
                        style={{marginTop: '10px'}}
                        id="visible"
                        name="visible"
                        component={renderVisibleCheckBox}
                        label="Visible"
                    />
                    <Field
                        id="title"
                        name="title"
                        component={renderTextField}
                        label={this.props.t("generic.title")}
                        fullWidth={true}
                    />
                    <Field
                        id="excerpt"
                        name="excerpt"
                        component={ControlledEditor}
                        initialValue={this.props.initialValues ? this.props.initialValues.excerpt : ""}
                        label={this.props.t("generic.excerpt")}
                        fullWidth={true}
                    />
                    <Field
                        id="content"
                        name="content"
                        component={ControlledEditor}
                        initialValue={this.props.initialValues ? this.props.initialValues.content : ""}
                        label={this.props.t("generic.content")}
                        fullWidth={true}
                    />
                    <Field
                        id="tag"
                        name="tag"
                        component={renderTextField}
                        label="Tag"
                        fullWidth={true}
                    />
                    <Field
                        id="types_id"
                        name="types_id"
                        label="Types"
                        style={{marginTop: 30}}
                        component={renderSuperSelectField}
                        fullWidth={true}
                        selectionsRenderer={this.renderTypesSelection}
                        normalize={values => {
                            if (!values) {
                                return []
                            }

                            return values.map(({value, label}) => {
                                return value;
                            });
                        }}
                        format={values => {
                            if (!values) {
                                return []
                            }

                            return values.map(typeId => {
                                const type = this.props.types.find(type => type.id === typeId);
                                return {
                                    value: typeId,
                                    label: type ? type.name : typeId
                                };
                            });
                        }}
                    >
                        {this.props.types.map((type) => (
                            <div key={type.id} value={type.id} label={type.name}>
                                <Avatar
                                    style={styles.margin.right.small}
                                    icon={type.picture &&
                                    <img src={type.picture} alt="" style={styles.image.contain} />}
                                    size={20}
                                    backgroundColor={type.color}
                                />
                                {type.name}
                            </div>
                        ))}
                    </Field>
                    {this.props.customFields && this.props.customFields.map((cf) => {
                        let name = cf.name;

                        if (cf.tag && cf.tag.length > 0) {
                            name += ' (' + cf.tag + ')'
                        }
                        if (cf.type === RICHTEXT) {
                            return (
                                <Field
                                    key={cf.id}
                                    id={cf.id}
                                    name={cf.id}
                                    component={ControlledEditor}
                                    initialValue={this.props.initialValues
                                        ? this.props.initialValues[cf.id]
                                        : ''}
                                    label={name}
                                    fullWidth={true}
                                />
                            );
                        } else {
                            return (
                                <Field
                                    key={cf.id}
                                    id={cf.id}
                                    name={cf.id}
                                    component={renderTextField}
                                    label={name}
                                    fullWidth={true}
                                />
                            );
                        }
                    })}
                    {this.props.app !== undefined &&
                    ModuleService.hasModule(this.props.app, ModuleService.PUSH) &&
                    ModuleService.isPushModuleConfigured(this.props.app) &&
                    (this.props.news === undefined || this.props.news.id !== undefined) &&
                        <Field
                        name="push_entity"
                        component={renderCheckbox}
                        label={this.props.t('module.push.push_entity')}
                    />
                    }
                </div>
                <div style={styles.formButtons}>
                    <RaisedButton
                        style={styles.formButton}
                        label={this.props.t("generic.save")}
                        disabled={pristine || submitting}
                        type="submit"
                        primary={true}
                    />
                    {this.props.news === undefined &&
                    <RaisedButton
                        style={styles.formButton}
                        label={this.props.t("generic.save_and_create_new")}
                        disabled={pristine || submitting}
                        type="button"
                        primary={true}
                        onClick={() => {
                            // In case of success, handle submit returns undefined, otherwise it returns the list of errors
                            if (handleSubmit() === undefined) {
                                this.onResetForm();
                            }
                        }}
                    />
                    }
                    <RaisedButton
                        style={styles.formButton}
                        label={this.props.t("generic.reset")}
                        type="button"
                        disabled={pristine || submitting}
                        onClick={this.onResetForm}
                    />
                </div>
            </form>
        );
    }
}

export default reduxForm({
    form: 'editNews',
    validate
})(withTranslation(NewsForm));



// WEBPACK FOOTER //
// src/components/news/NewsForm.js